import { render, staticRenderFns } from "./SpotBadge.vue?vue&type=template&id=f92d6420"
import script from "./SpotBadge.vue?vue&type=script&lang=js"
export * from "./SpotBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports